import { render, staticRenderFns } from "./selectReasonAction.vue?vue&type=template&id=127f7bdb&scoped=true"
import script from "./selectReasonAction.vue?vue&type=script&lang=js"
export * from "./selectReasonAction.vue?vue&type=script&lang=js"
import style0 from "./selectReasonAction.vue?vue&type=style&index=0&id=127f7bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f7bdb",
  null
  
)

export default component.exports